export function TitleForTables({ title }) {
  return (
    <div
      style={{
        backgroundColor: "var( --color-orange-light-opacity)",
        opacity: 50,
        borderRadius: 5,
        padding: 10,
        textAlign: "center",
      }}
    >
      <h3>{title}</h3>
    </div>
  );
}
